// Web Notifications scheduler — checks every 30s for doses due in the next `lead` minutes
import { rx } from "./api";

const NOTIFIED_KEY = "handy_notified_doses";
const SETTINGS_KEY = "handy_reminder_settings";

export function getReminderSettings() {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) { /* ignore */ }
  return { enabled: true, leadMinutes: 10 };
}

export function setReminderSettings(s) {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(s));
}

function getNotified() {
  try { return JSON.parse(localStorage.getItem(NOTIFIED_KEY) || "[]"); } catch { return []; }
}
function addNotified(id) {
  const arr = getNotified();
  if (!arr.includes(id)) {
    arr.push(id);
    localStorage.setItem(NOTIFIED_KEY, JSON.stringify(arr.slice(-500)));
  }
}

export async function requestNotifPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  const p = await Notification.requestPermission();
  return p;
}

let pollTimer = null;
let popupHandler = null;

export function setPopupHandler(fn) { popupHandler = fn; }
export function firePopup(data) { if (popupHandler) popupHandler(data); }

async function pollOnce() {
  const settings = getReminderSettings();
  if (!settings.enabled) return;
  try {
    const list = await rx.list();
    const now = Date.now();
    const notified = getNotified();
    for (const r of list) {
      const data = await rx.get(r.id);
      for (const d of data.doses) {
        if (d.status !== "pending") continue;
        if (notified.includes(d.id)) continue;
        const t = new Date(d.scheduled_at).getTime();
        const diffMin = (t - now) / 60000;
        if (diffMin <= settings.leadMinutes && diffMin >= -5) {
          // fire notification + in-app popup
          const doseLabel = d.dose_label || r.dosage;
          const title = `Time to take ${r.medicine_name}`;
          const body = `${doseLabel}${r.instructions ? " · " + r.instructions : ""}`;
          if ("Notification" in window && Notification.permission === "granted") {
            try { new Notification(title, { body, tag: d.id }); } catch (e) { /* ignore */ }
          }
          if (popupHandler) popupHandler({ prescription: r, dose: d });
          addNotified(d.id);
        }
      }
    }
  } catch (e) {
    // silent
  }
}

export function startReminderPolling() {
  if (pollTimer) return;
  pollOnce();
  pollTimer = setInterval(pollOnce, 30000);
}

export function stopReminderPolling() {
  if (pollTimer) clearInterval(pollTimer);
  pollTimer = null;
}
